import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { formatCentsToUSD } from '../../../../../../../shared/lib/utils';
import WideImage from './WideImage';
import SpinnerButton from './SpinnerButton';

export interface RectangleCardProps {
  name: string;
  price?: number;
  description?: string;
  singleMode?: boolean;
  buttonLabel?: string;
  image?: string;
  amount?: number;
  error?: string;
  disabled?: boolean;
  setAmount?: (amount: number) => void;
  buttonOverride?: React.ReactNode;
}

export default function RectangleCard(props: RectangleCardProps) {
  const {
    name,
    description,
    singleMode,
    buttonLabel,
    price,
    image,
    error,
    amount = 0,
    disabled,
    setAmount,
    buttonOverride,
  } = props;

  return (
    <fieldset
      className="rounded-lg overflow-hidden border border-border bg-white px-5 py-3 grid grid-cols-1 gap-4"
      disabled={disabled}
    >
      <div className="flex flex-wrap items-center gap-4">
        <div style={{ width: 100, flexShrink: 0 }}>
          <WideImage image={image} title={name} />
        </div>
        <div className="grid grid-cols-1 gap-1 flex-grow">
          <div className="font-bold text-accent">{name}</div>
          {price !== undefined && <div className="text-sm">{formatCentsToUSD(price)}</div>}
        </div>
        {error && <div className="font-semibold text-error">{error}</div>}
        {buttonOverride !== undefined
          ? buttonOverride
          : setAmount && (
              <SpinnerButton
                type="addon"
                singleMode={singleMode}
                buttonLabel={buttonLabel}
                amount={amount}
                setAmount={setAmount}
              />
            )}
      </div>
      {description && (
        <div className="html-view" dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
    </fieldset>
  );
}
